
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"11","cy":"11","r":"11","fill":"#FF3C3C"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.32 14.58c-1.715-.807-3.208-1.51-5.135-1.407-3.697-9.844 8.7-11.66 10.335-4.146h.003l.977 4.22h-.01l.01.002c-.016 1.138-.444 2.434-1.11 3.151-2.088-.417-3.655-1.154-5.07-1.82zm5.244-1.598l-1.037-4.14-4.604-.866c-.13-.024-.265.2-.235.334l.613 2.738c.067.301.374.538.659.62l4.604 1.314z","fill":"#fff"}})])
          )
        }
      }
    